import LayoutWithSidebar from "../components/LayoutWithSidebar";
import RegisterSideMenu from "../components/RegisterSideMenu";
import MainHeaderContainer from "../containers/MainHeaderContainer";
import RequestPermitContainer from "../containers/RequestPermitContainer";
import { Grid, GridColumn } from "semantic-ui-react";

const RequestPermitPage = () => {
  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return (
      <Grid>
        <Grid.Row>
          <GridColumn only="mobile">
            <RegisterSideMenu iconOnly={true}></RegisterSideMenu>
          </GridColumn>
          <GridColumn only="tablet computer">
            <RegisterSideMenu iconOnly={false}></RegisterSideMenu>
          </GridColumn>
        </Grid.Row>
      </Grid>
    );
  };

  const contentPanelContent = () => {
    return <RequestPermitContainer></RequestPermitContainer>;
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default RequestPermitPage;
